import React from 'react';
import SvgIcon from './SvgIcon';

const Comfortable = props => {
    return (
        <SvgIcon viewBox="0 0 24 24" {...props}>
            <path
                d="M.75 12h22.5M12 .75v22.5V.75zM.75 1.75a1 1 0 011-1h20.5a1 1 0 011 1v20.5a1 1 0 01-1 1H1.75a1 1 0 01-1-1V1.75z"
                stroke="currentColor"
                strokeMiterlimit={10}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </SvgIcon>
    );
};

Comfortable.displayName = 'ComfortableIcon';

export default Comfortable;
